import type { AppCopy } from '../catalogs';

export const daAppCopy = {
  welcomeHeading: 'Hvordan kan jeg hjælpe dig i dag?',
  thinking: 'Tænker',
  scrollToBottom: 'Rul til bunden',
  reasoning: 'Ræsonnement',
  reasoningInProgress: 'i gang',
  citationPages: 'Sider {first}–{last}',
  citationTitle: 'Kildeuddrag',
  citationLoading: 'Henter kilde…',
  citationUnavailable: 'Den citerede tekst er utilgængelig, eller du har ikke længere adgang.',
  citationOpen: 'Åbn kilde',
  citationCopied: 'Kildehenvisning kopieret',
  copy: 'Kopiér',
  more: 'Mere',
  tryAgain: 'Prøv igen',
  answerTruncated: 'Svaret nåede længdegrænsen og blev afbrudt.',
  continueAnswer: 'Fortsæt svaret',
  exportMarkdown: 'Eksporter som Markdown',
  edit: 'Rediger',
  cancel: 'Annuller',
  update: 'Opdatering',
  previous: 'Forrige',
  next: 'Næste',
  messagePlaceholder: 'Send en besked...',
  projectHomePlaceholder: 'Ny chat i {project}',
  sharedChatEveryone: 'Alle hos {company} kan læse denne chat',
  sharedChatOnePerson: '1 person kan læse denne chat',
  sharedChatPeople: '{count} personer kan læse denne chat',
  forkedChatPlaceholder: 'Fortsæt med dine egne forbindelser…',
  newAnswer: 'Nyt svar',
  messageInput: 'Besked input',
  sendMessage: 'Send besked',
  stopGenerating: 'Stop med at generere',
  addAttachment: 'Tilføj vedhæftet fil',
  removeFile: 'Fjern fil',
  attachmentPreview: 'Forhåndsvisning af vedhæftede filer',
  imageAttachmentPreview: 'Forhåndsvisning af billedvedhæftning',
  image: 'Billede',
  openLink: 'åbent link',
  document: 'Dokument',
  file: 'Fil',
  attachment: 'vedhæftet fil',
  uploadFailed: 'upload mislykkedes',
  uploading: 'uploader',
  toolIncomplete: 'Ufuldstændigt',
  toolActivity: 'Aktivitet',
  activityThinking: 'Tænker…',
  activityWriting: 'Skriver…',
  activityWaiting: 'Venter på din godkendelse',
  activityStopped: 'Stoppet',
  activityCouldNotFinish: 'Kunne ikke gøre det færdigt',
  activitySources: 'kilder',
  activityShowThinking: 'Vis tænkning',
  activityOpen: 'Åbn aktivitet',
  activitySteps: 'Trin',
  activitySourcesTab: 'Kilder',
  activityUnavailable: 'Denne aktivitet er ikke tilgængelig.',
  activityInput: 'Input',
  activityOutput: 'Output',
  activityNoSources: 'Dette svar citerede ingen kilder.',
  activityApprovedByReply: 'Godkendt af dit svar',

  toolRunning: 'Arbejder',
  toolComplete: 'Fuldført',
  toolNeedsApproval: 'Kræver godkendelse',
  toolInput: 'Input',
  toolCall: 'værktøjsopkald',
  toolCalls: 'værktøjskald',
  openMenu: 'Åbn menuen',
  closeMenu: 'Luk menuen',
  close: 'Luk',
  showInTextField: 'Vis i tekstfelt',
  settings: 'Indstillinger',
  appearance: 'Udseende',
  themeLight: 'Lyst',
  themeDark: 'Mørkt',
  themeSystem: 'System',
  themeChoiceHelp:
    'Gælder på alle dine enheder. System følger hver enheds lyse eller mørke tilstand.',
  themeSaveFailed: 'Vi kunne ikke gemme udseendet, så det er uændret. Prøv igen.',
  toolUsed: 'Brugt værktøj',
  toolCancelled: 'Annulleret værktøj',
  toolResult: 'Resultat:',
  toolError: 'Fejl:',
  toolCancelledReason: 'Årsag til annullering:',
  approvalAllow: 'Tillad',
  approvalAlwaysAllow: 'Tillad altid',
  approvalDeny: 'Afvis',
  approvalAlwaysDeny: 'Afvis altid',
  approvalConfirm: 'Bekræft',
  approvalBack: 'Tilbage',
  approvalApprovedResult: 'Godkendt af bruger',
  approvalDeniedResult: 'Brugeren afviste kørsel af værktøjet',
  logout: 'Log ud',
  loginOrCreateAccount: 'Log ind / Opret konto',
  newChat: 'Ny chat',
  untitledChat: 'Unavngivet chat',
  previousChats: 'Tidligere chats',
  openChat: 'Åbn chat {title}',
  moreActionsForChat: 'Flere handlinger til {title}',
  chatActions: 'Chathandlinger',
  closeChatActions: 'Luk chathandlinger',
  deleteChatQuestion: 'Vil du slette chatten?',
  deleteChatDescription: 'Chatten "{title}" slettes permanent.',
  deleteChat: 'Slet chat',
  keepChat: 'Behold chatten',
  delete: 'Slet',
  deleting: 'Sletter...',
  chatDeleteFailed: 'Chatten kunne ikke slettes. Prøv igen.',
  settingsDescription: 'Tilpas, hvordan assistenten fungerer for dig.',
  settingsDesktopDescription: 'Tilpas, hvordan assistenten reagerer på dig.',
  personalization: 'Personalisering',
  personalizationDescription: 'Tilpas instruktionerne, som assistenten følger i hvert svar.',
  languageAndRegion: 'Sprog og region',
  languageAndRegionDescription: 'Vælg sprog og tidszone.',
  memories: 'Erindringer',
  memoriesDescription: 'Se, rediger eller slet det, assistenten husker om dig.',
  account: 'Konto',
  accountDescription: 'Administrer kontoen og permanent sletning af dine data.',
  backToSettings: 'Tilbage til indstillinger',
  closeSettings: 'Luk indstillinger',
  settingsCategories: 'Indstillingskategorier',
  yourSettings: 'Dine indstillinger',
  dataAndAccount: 'Data og konto',
  viewAndManageMemories: 'Se og administrer, hvad assistenten husker',
  loginToUseMemories: 'Log ind for at bruge minder',
  manageOrDeleteAccount: 'Administrer eller slet kontoen',
  unsavedChanges: 'Du har ikke-gemte ændringer',
  unsavedCloseDescription: 'Lukning af indstillinger vil kassere ændringerne på denne side.',
  unsavedBackDescription: 'Går tilbage vil ændringerne på denne side kasseres.',
  continueEditing: 'Fortsæt med at redigere',
  discardChanges: 'Kassér ændringer',
  saveChanges: 'Gem ændringer',
  localSettingsNote: 'Gemt i denne browser. Log ind for at gemme på din konto.',
  personality: 'Personlighed',
  personalityHelp: 'Brugerdefinerede instruktioner, som assistenten følger i hvert svar',
  personalityPlaceholder:
    'For eksempel: Vær kortfattet og konkret. Jeg bor i Gøteborg og kan godt lide vegetarisk mad.',
  timezone: 'Tidszone',
  searchTimezone: 'Søg tidszoner...',
  automaticBrowser: 'Automatisk (browser)',
  saved: 'Gemt {date}',
  addMemory: 'Tilføj minde',
  newMemory: 'Nyt minde',
  memoryPlaceholder: 'For eksempel: Jeg foretrækker korte, konkrete svar.',
  editMemory: 'Rediger minde',
  saveMemory: 'Gem minde',
  deleteMemory: 'Slet minde',
  memorySaveFailed: 'Hukommelsen kunne ikke gemmes. Prøv igen.',
  memoryLimitReached: 'Du kan gemme op til 50 minder. Slet et, før du tilføjer et nyt.',
  memoryInvalid: 'Minder må ikke indeholde links. Fjern linket, og prøv igen.',
  memoryDeleteFailed: 'Hukommelsen kunne ikke slettes. Prøv igen.',
  memoryLoadFailed: 'Minder kunne ikke indlæses.',
  loadingMemories: 'Indlæser minder...',
  emptyMemories:
    'Assistenten gemmer minder om dig, mens du taler - hvad du kan lide, hvor du bor, og hvad du laver. Du kan se, redigere og slette dem her.',
  deleteAccountHelp: 'Slet permanent kontoen og alle relaterede chats, minder og indstillinger.',
  deleteAccount: 'Slet konto',
  deleteAccountQuestion: 'Vil du slette kontoen permanent?',
  deleteAccountDescription:
    'Alle chats, beskeder, minder, indstillinger og loginoplysninger vil blive slettet. Denne handling kan ikke fortrydes.',
  deleteAccountConfirm: 'Ja, slet min konto',
  accountDeleteFailed: 'Kontoen kunne ikke slettes. Intet blev fjernet – prøv igen.',
  logoutEverywhereTitle: 'Alle enheder',
  logoutEverywhereHelp: 'Log ud på alle enheder og browsere, hvor din konto er åben, også denne.',
  logoutEverywhere: 'Log ud overalt',
  logoutEverywhereQuestion: 'Log ud på alle enheder?',
  logoutEverywhereDescription:
    'Du skal logge ind igen på alle enheder og browsere, også denne. Dine chats og indstillinger forbliver, som de er.',
  loggingOut: 'Logger ud…',
  logoutEverywhereFailed:
    'Vi kunne ikke bekræfte, at du blev logget ud overalt. Prøv igen, eller tjek på en anden enhed, om du stadig er logget ind.',
  settingsSaveFailed: 'Indstillinger kunne ikke gemmes. Prøv igen.',
  customInstructions: 'Brugerdefinerede instruktioner',
  notSet: 'Ikke indstillet',
  automaticLanguage: 'Automatisk sprog',
  automaticTimezone: 'automatisk tidszone',
  appLanguage: 'App sprog',
  appLanguageHelp:
    'Styrer hele appens brugerflade og datoer. Assistentens svar følger fortsat det sprog, du skriver på.',
  automaticBrowserLanguage: 'Automatisk (browsersprog)',
  previousLanguageChoice: 'Tidligere valg: {language} ({locale})',
  previousLanguageChoiceCode: 'Tidligere valg ({locale})',
  canvasCopyLink: 'Kopiér link',
  canvasLinkCopied: 'Linket er kopieret',
  actionUpdatedWithEdits: 'Opdateret med dine ændringer',
  activityStepsDone: 'one:trin udført|other:trin udført',
  activityResultsCount: 'one:resultat|other:resultater',
  canvasCopyLinkFailed: 'Linket kunne ikke kopieres',
  canvasOpenInAgent: 'Åbn i {agent}',
  canvasExpand: 'Udvid',
  canvasExitFullView: 'Afslut fuld visning',
  webSourceUnread: 'Linket i dette svar. Poneva har ikke læst siden, så der er intet at vise her.',
  webSourceOpenOriginal: 'Åbn originalen',
  toolProgressSettings: 'Ændrer dine indstillinger…',
  toolProgressAgent: 'Opretter agenten…',
  toolProgressConnections: 'Finder forbindelsesmuligheder…',
  toolProgressResult: 'Forbereder dit resultat…',
  toolProgressClarification: 'Forbereder en uddybning…',
  toolProgressKnowledge: 'Forbereder et forslag til opdatering af viden…',
  toolProgressQuestion: 'Forbereder et spørgsmål til dig…',
  toolProgressSkill: 'Former din Skill…',
  toolErrorSettings: 'Dine indstillinger blev ikke ændret.',
  toolErrorAgent: 'Agenten kunne ikke oprettes.',
  toolErrorConnections: 'Forbindelsesmulighederne kunne ikke indlæses.',
  toolErrorResult: 'Resultatet blev ikke gemt.',
  toolErrorClarification: 'Uddybningen kunne ikke forberedes.',
  toolErrorKnowledge: 'Forslaget til opdatering af viden kunne ikke forberedes.',
  toolErrorQuestion: 'Spørgsmålet kunne ikke forberedes.',
  toolErrorSkill: 'Skill-udkastet kunne ikke gemmes.',
  toolErrorOpenSettings: 'Åbn Indstillinger',
  toolErrorOpenAgents: 'Åbn Agenter',
  toolErrorOpenConnections: 'Åbn Forbindelser',
  toolStepIncomplete: 'Dette trin blev ikke fuldført.',
  toolEarlierAttemptsFailed:
    'one:tidligere forsøg lykkedes ikke|other:tidligere forsøg lykkedes ikke',
} satisfies AppCopy;
